import { render, staticRenderFns } from "./ReportStatusChip.vue?vue&type=template&id=663f9fb8"
import script from "./ReportStatusChip.vue?vue&type=script&lang=js"
export * from "./ReportStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports